// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Bookings__PriceCalculatorController from "./bookings/price_calculator_controller"
application.register("bookings--price-calculator", Bookings__PriceCalculatorController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import Forms__CharacterLimitFeedbackController from "./forms/character_limit_feedback_controller"
application.register("forms--character-limit-feedback", Forms__CharacterLimitFeedbackController)

import Forms__FileFieldController from "./forms/file_field_controller"
application.register("forms--file-field", Forms__FileFieldController)

import Forms__TrixEditorController from "./forms/trix_editor_controller"
application.register("forms--trix-editor", Forms__TrixEditorController)

import Images__LoadingController from "./images/loading_controller"
application.register("images--loading", Images__LoadingController)

import Images__SlideShowController from "./images/slide_show_controller"
application.register("images--slide-show", Images__SlideShowController)

import Maps__GeocodingController from "./maps/geocoding_controller"
application.register("maps--geocoding", Maps__GeocodingController)

import Messages__AutoScrollController from "./messages/auto_scroll_controller"
application.register("messages--auto-scroll", Messages__AutoScrollController)

import Navigations__NavbarController from "./navigations/navbar_controller"
application.register("navigations--navbar", Navigations__NavbarController)

import Navigations__SidebarController from "./navigations/sidebar_controller"
application.register("navigations--sidebar", Navigations__SidebarController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import Overlays__DrawerController from "./overlays/drawer_controller"
application.register("overlays--drawer", Overlays__DrawerController)

import Overlays__ModalDialogController from "./overlays/modal_dialog_controller"
application.register("overlays--modal-dialog", Overlays__ModalDialogController)

import Payments__CheckoutController from "./payments/checkout_controller"
application.register("payments--checkout", Payments__CheckoutController)
